import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  DayDepthChartWidgetEntity,
  TDayDepthSerializedInternalState,
} from 'src/pages/dashboard/features/well-day-depth-widget/DayDepthChartWidget.entity';

export function serializeDayDepthChartWidget(widget: DayDepthChartWidgetEntity): TSerializedWidget {
  const internalState: TDayDepthSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      timeZone: widget.stateParams.timeZone,
      legendVisible: widget.stateParams.legendVisible,
      autoScroll: widget.stateParams.autoScroll,
      infoPanels: widget.stateParams.infoPanels,
      offsetX: widget.stateParams.offsetX,
      offsetY: widget.stateParams.offsetY,
      zoomTime: widget.stateParams.zoomTime,
      zoomDepth: widget.stateParams.zoomDepth,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
